<template>
  <div class="notice">
    <div class="container">
      <div class="cn-block">
        <span class="line"></span>
        <span class="text">办理流程</span>
        <div class="busstype" v-for="item in items" :key="item.modelId" :text="item.title">
          {{item.stepName}}
          <div class="triangle"></div>
        </div>
      </div>
      <div v-for="step in stepInfos" :key="step.id" class="cn-block">
        <span class="line"></span>
        <span class="text">{{step.title}}</span>
        <div class="busstype" style="text-align: left;">
          <div class="download-msg" v-html="step.content"></div>
        </div>
      </div>
    </div>
    <div class="go-business button-primary" @click="goPage()">办理</div>
  </div>
</template>
<script>
import Vue from 'vue'
import { Notify, Grid, GridItem, Icon, Image as VanImage } from 'vant'
import { startBusinessReq, nextBusinessReq } from '@/api/manage'
// import { fetchPost } from '../../utils/axiosfunc.js'

Vue.use(Notify)
Vue.use(Grid)
Vue.use(GridItem)
Vue.use(VanImage)
Vue.use(Icon)

export default {
  data () {
    return {
      items: [],
      stepInfos: [],
      serviceId: '',
      userAccount: '',
      userName: '',
      datas: ''
    }
  },
  components: {
  },
  created () {
    // 隐藏父路由底部logo
    this.$parent.footer(true)

    // 获取路由参数
    const query = this.$route.query
    this.serviceId = query.serviceId
    if (query.userAccount) {
      this.userAccount = query.userAccount
      this.userName = query.userName
    }

    // 创建业务
    this.startBusiness()
  },
  methods: {
    goPage () {
      const params = {
        token: this.$cookies.get('token'),
        openId: this.$cookies.get('openid'),
        currentModelId: this.datas.modelId,
        linkedId: this.datas.linkedId,
        data: '',
        type: -1
      }
      nextBusinessReq(params).then(response => {
        const res = response.data
        console.log(res)
        if (res.code === 200) {
          const localPage = res.data.localPage
          this.$router.push({
            path: localPage,
            query: {
              token: this.$cookies.get('token'),
              linkedId: res.data.linkedId,
              userAccount: this.userAccount,
              userName: this.userName
            }
          })
        }
      })
        .catch((res) => {
          Notify({ type: 'danger', message: '获取下一步业务失败' })
        })
    },
    startBusiness () {
      const params = {
        token: this.$cookies.get('token'),
        openId: this.$cookies.get('openid'),
        serviceId: this.serviceId,
        tel: ''
      }
      startBusinessReq(params).then(response => {
        const res = response.data
        this.datas = res.data
        console.log(res)
        if (res.code === 200) {
          // 修改父路由头部文字
          this.$parent.changeBusstypeText(res.data.serviceName, '')
          this.items = res.data.frontLinkeds
          for (let i = 0; i < res.data.stepInfoForms.length; i++) {
            if (res.data.stepInfoForms[i].content.indexOf('${}')) {
              var htmlDom = '<a href="' + this.filePath + res.data.stepInfoForms[i].filePath + '">' + res.data.stepInfoForms[i].fileTitle + '</a>'
              res.data.stepInfoForms[i].content = res.data.stepInfoForms[i].content.replace('${}', htmlDom)
            }
          }
          this.stepInfos = res.data.stepInfoForms
        }
      })
        .catch((res) => {
          Notify({ type: 'danger', message: '获取业务须知失败' })
        })
    }
  }
}
</script>
<style lang="less" scoped>
  .notice {
    margin-bottom: 20px;
  }
  .notice .container {
    margin: 0 25px;
    padding-top: 15px;
    padding-bottom: 5px;
  }
  .cn-block .line {
    width: 4px;
    height: 16px;
    background-color: #008ACB;
    display: inline-block;
    margin-right: 10px;
  }
  .cn-block .text {
    font-size: 16px;
    color: #646566;
  }
  .cn-block .busstype {
    background-color: #ffffff;
    padding: 15px 10px;
    text-align: center;
    margin: 20px 0;
    color: #727272;
    font-size: 16px;
    -webkit-box-shadow: #999 0px 0px 5px;
    -moz-box-shadow: #999 0px 0px 5px;
    box-shadow: #999 0px 0px 5px;
    line-height: 25px;
    border-radius: 4px;
    position: relative;
    margin-bottom: 30px;
  }
  .cn-block .busstype:not(:last-child)::after {
    position: absolute;
    bottom: -9px;
    left: 49%;
    content: '';
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 10px solid #ffffff;
    filter: drop-shadow(1px 3px 1px rgba(0, 0, 0, .2));
  }
  .cn-block .busstype:last-child::after {
    background-color: #ffffff;
    padding: 15px 10px;
    text-align: center;
    margin: 20px 30px;
    color: #727272;
    font-size: 16px;
    -webkit-box-shadow: #999 0px 0px 5px;
    -moz-box-shadow: #999 0px 0px 5px;
    box-shadow: #999 0px 0px 5px;
    line-height: 25px;
    border-radius: 4px;
    position: relative;
    margin-bottom: 30px;
  }
  .cn-block .busstype .download-msg a {
    color: #1EB1E7;
    display: inline-block;
  }
  .go-business {
    margin-left: 25px;
    width: calc(100% - 50px);
    display: inline-block;
    margin-top: 0px;
    text-align: center;
  }
  .button-primary {
    height: 48px;
    line-height: 48px;
    background-color: #008ACB;
    font-size: 16px;
    color: #fff;
    border-top-left-radius: 24px;
    border-bottom-left-radius: 24px;
    border-top-right-radius: 24px;
    border-bottom-right-radius: 24px;
  }
</style>
